import { z } from 'zod'

export const appVersionSchema = z.object({
  application_id: z.coerce.number().min(1, 'Application is required'),
  version: z.string().min(1, 'Version is required').max(50),
  build: z.string().max(50).optional().or(z.literal('')),
  min_supported_version: z.string().max(50).optional().or(z.literal('')),
  is_mandatory: z.boolean(),
  rollout_percent: z.coerce.number().min(0).max(100),
  release_notes: z.string().optional(),
  download_url: z.string().min(1, 'Download URL is required').max(500),
  checksum: z.string().max(128).optional().or(z.literal('')),
  published_at: z.string().optional().or(z.literal('')),
})

export type AppVersionFormData = z.infer<typeof appVersionSchema>
